import React from 'react';
import ThreeYearsLandingPage from 'modules/promotions/threeYears/ThreeYearsLandingPage';

export default function ThreeYearsAnniversary() {
    return <ThreeYearsLandingPage />;
}
